import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  appConfig: {
    API_URL: 'https://nearlive-globo-api.azure-api.net/globo-nearlive/dev/',
    API_KEY: 'e903f8b4948a445d80dfd0ae0b2397c1',
    STORAGE_KEY: 'storagenot_nearlive_globo__dev_01',
    ENVIRONMENT: 'd',
    INSIGHTS: '04fb2076-f797-4570-ab86-f18e3ebe2f76',
    APPID: '1:1088634414899:web:8c3b2e7a0c8f1e5b4c8d9',
    TENANT: 'globo.onmicrosoft.com',
    PACKAGE_NAME: 'com.globo.nearlive',
    HASH_ANDROID: 'd41d8cd98f00b204e9800998ecf8427e',
  },
};
